import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';


@Injectable({
  providedIn: 'root'
})
export class UserDataService {

  constructor( 
    private storage: Storage) {
      this.init();
  }
  //
 
  async init() {
    const storage = await this.storage.create();
  }

  setUserContact(data: any): Promise<any> {
    //  console.log(data);
      return  this.storage.set('user_contact', data);
    }
    async getUserContact(): Promise<any> {
      return await this.storage.get('user_contact');
    }
    async removeUserContact(): Promise<any> {
      return await this.storage.get('user_contact');
    }
    
   setUserData(data: any): Promise<any> {
  //  console.log(data);
    return  this.storage.set('user_data', data);
  }
  async getUserLoginData(): Promise<any> {
    return await this.storage.get('user_data');
  }

  async removeUserLoginData(): Promise<any> {
    return await this.storage.remove('user_data');
  }
  setStudentData(data: any): Promise<any> {
    //  console.log(data);
      return  this.storage.set('student_data', data);
  }
  async getStudentLoginData(): Promise<any> {
    return await this.storage.get('student_data');
  }

  async removeStudentLoginData(): Promise<any> {
    return await this.storage.remove('student_data');
  }

  setPaymentData(data: any): Promise<any> {
    //  console.log(data);
      return  this.storage.set('payment_data', data);
  }
  async getPaymentData(): Promise<any> {
    return await this.storage.get('payment_data');
  }

  async removePaymentData(): Promise<any> {
    return await this.storage.remove('payment_data');
  }
  async setUserExamData(key: string, data: any): Promise<any> {
    // console.log(data)
    return await this.storage.set(key, data);
  }
  async getUserExamData(key: string): Promise<any> {
   // console.log(key);
    return await this.storage.get(key);
  }
}
